import React from 'react';

export default function Logo(props) {
  return (
    <div align={props.align}>
      <img 
        src={props.src} 
        height={props.height}
        alt={props.alt}
      >
      </img>
    </div>
  );
};